window.PRPurchase = window.PRPurchase || {};

window.Shopify = window.Shopify || {};
window.Shopify.formatMoney =
  window.Shopify.formatMoney ||
  function (cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(Number(cents) / 100);
  };

window.PRPurchase.formatMoney = function (cents) {
  return window.Shopify.formatMoney(cents);
};

window.PRPurchase.formatMoneyFlex = function (cents) {
  let value = cents;
  if (typeof value === 'string') value = value.replace('.', '');
  value = Number(value) || 0;
  const hasCents = value % 100 !== 0;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  }).format(value / 100);
};

window.PRPurchase.formatMoney2 = function (cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(cents) / 100);
};

// "Free U.S. Shipping on orders $99+" (the announcement bar in header-group.json)
// is the promise every card has to match. Held here rather than copied into each
// flavour script so the four PDPs cannot drift from the banner or from one
// another -- they previously all carried their own $100 constant, which quoted
// $6.95 on a $99 order the banner had already promised to ship free.
window.PRPurchase.FREE_SHIPPING_THRESHOLD_CENTS = 9900;
// The fee itself is quoted only where it is charged -- the Buy Once link and
// card -- so every flavour states it in the same words.
window.PRPurchase.DEFAULT_SHIPPING_TEXT = '$6.95 shipping';

// A flavour whose one-off ships light quotes the lower US rate instead: the
// widget carries it as data-shipping-text on the container (set per flavour
// in pr-rtx-{oil,mist,yummies}.liquid), so the script and the Liquid first
// paint cannot disagree. Rose + Rosehip Oil is the case that prompted this --
// a single small bottle ships for $4.95, and the card said $6.95.
window.PRPurchase.shippingText = function (container) {
  return (container && container.dataset && container.dataset.shippingText) || window.PRPurchase.DEFAULT_SHIPPING_TEXT;
};

window.PRPurchase.qualifiesForFreeShipping = function (cents) {
  return Number(cents) >= window.PRPurchase.FREE_SHIPPING_THRESHOLD_CENTS;
};

// Mirrors the direct-add links in the offers snippets (the "Try 2oz" link in
// pr-offers-mist.liquid): these bypass product-form, which is what normally
// re-renders the header bubble, and Rebuy's Smart Cart opens off the /cart/add
// request itself -- so do not navigate afterwards or the drawer races the
// cart page.
window.PRPurchase.addToCart = function (variantId, quantity) {
  const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(addUrl + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({
      items: [{ id: Number(variantId), quantity: quantity || 1 }],
      sections: ['cart-icon-bubble'],
      sections_url: window.location.pathname,
    }),
  })
    .then(function (res) {
      if (!res.ok) throw new Error('add-to-cart failed');
      return res.json();
    })
    .then(function (data) {
      const section = data && data.sections && data.sections['cart-icon-bubble'];
      const bubble = document.getElementById('cart-icon-bubble');
      if (section && bubble) {
        const parsed = new DOMParser().parseFromString(section, 'text/html').querySelector('.shopify-section');
        if (parsed) bubble.innerHTML = parsed.innerHTML;
      }
      if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.open === 'function') {
        window.Rebuy.SmartCart.open();
      }
      return data;
    });
};

window.PRPurchase.readPlans = function () {
  const el = document.getElementById('pr-selling-plans');
  if (!el) return { hasPlans: false, kinds: {}, variants: {} };
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return { hasPlans: false, kinds: {}, variants: {} };
  }
};

window.PRPurchase.readProduct = function (form) {
  const root =
    form.closest('[data-section-type="product-template"]') ||
    form.closest('[data-product-container]');
  const sectionId = root ? root.dataset.sectionId : null;
  const script = sectionId
    ? root.querySelector('#ProductJson-' + sectionId)
    : document.querySelector('script[type="application/json"][data-product-json]');
  if (script) {
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return window.customProductData || null;
    }
  }
  return window.customProductData || null;
};

window.PRPurchase.parsePack = function (value) {
  if (!value) return 0;
  const m = String(value).match(/(\d+)/);
  return m ? parseInt(m[1], 10) : 0;
};

window.PRPurchase.packLabel = function (n) {
  return n + '-Pack';
};

window.PRPurchase.findVariant = function (productData, matchFn) {
  if (!productData || !productData.variants) return null;
  return productData.variants.find(matchFn) || null;
};

window.PRPurchase.variantRecord = function (plans, variantId) {
  if (!plans || !plans.variants || !variantId) return null;
  return plans.variants[String(variantId)] || null;
};

// `kind` alone is ambiguous: a variant can carry several allocations of the same
// kind from different selling-plan groups, and the generic percentage-discount
// groups often sort ahead of the product-specific fixed-price one. Taking the
// first match therefore prices from whichever group Shopify happens to return
// first (Rose + Rosehip Oil 1-Pack showed $62 from a 4.62% plan instead of the
// $55 fixed-price plan). Callers that know the exact plan pass `planId` to
// disambiguate, mirroring how the Brooklyn theme matched on plan_id.
window.PRPurchase.allocation = function (record, kind, planId) {
  if (!record || !record.allocations) return null;
  if (planId) {
    const exact = record.allocations.find(function (a) {
      return String(a.plan_id) === String(planId);
    });
    if (exact) return exact;
  }
  return record.allocations.find(function (a) {
    return a.kind === kind;
  }) || null;
};

window.PRPurchase.fillPriceDetails = function (label, price, formulaBase, months, isOnetime) {
  const pDisplay = label.querySelector('.current-price-display');
  const cDisplay = label.querySelector('.compare-at-price-display');
  const sLabel = label.querySelector('.savings-label');
  const sAmount = label.querySelector('.js-savings-amount');
  // `/mo` is a sibling of the price rather than part of the headline: $59 /mo.
  // Sized in pure-rose-pdp.css.
  const perMo = label.querySelector('.price-per-mo');
  const bTotal = label.querySelector('.js-billing-total');
  const bLabel = label.querySelector('.js-billing-label');
  const money = window.PRPurchase.formatMoneyFlex;

  // Savings in dollars, for the whole shipment rather than per month: the line
  // sits in the check list beside "3 x 64 servings every 3 months", so it has to
  // describe the same order those words do. Left empty when there is nothing to
  // save -- the :has(> strong:empty) rule in pure-rose-pdp.css drops the row.
  if (sAmount) {
    sAmount.textContent = formulaBase > price ? 'Save ' + money(formulaBase - price) : '';
  }

  // The subscription cards used to state "Free Shipping" unconditionally in the
  // markup, so a shipment under the threshold advertised delivery it does not
  // qualify for -- Rose Mist's 60-Day Supply bills $70 and still said free.
  // Stated from the amount this card actually charges per shipment, and only
  // when it earns the free rate: this row is a list of what the subscription
  // gets you, so a $6.95 charge does not belong in it. The fee is still
  // disclosed where it is paid -- the Buy Once link and card both quote it from
  // the flavour scripts. Left empty otherwise, which the
  // :has(> strong:empty) rule in pure-rose-pdp.css drops the row for.
  const cardShipping = label.querySelector('.js-card-shipping');
  if (cardShipping) {
    // The same words as the new buy box's cards (pr-buybox.liquid), in
    // Tor's final wording (22 Oct 2026).
    cardShipping.textContent = window.PRPurchase.qualifiesForFreeShipping(price) ? 'Free shipping on every order' : '';
  }

  if (isOnetime) {
    if (pDisplay) pDisplay.textContent = money(price);
    if (perMo) perMo.textContent = '';
    if (cDisplay) {
      if (formulaBase > price) {
        cDisplay.textContent = money(formulaBase);
        cDisplay.style.display = 'inline';
        cDisplay.style.visibility = 'visible';
      } else {
        cDisplay.style.display = 'none';
        cDisplay.style.visibility = 'hidden';
      }
    }
    if (sLabel) sLabel.style.display = 'none';
    return;
  }

  const divisor = months && months > 1 ? months : 1;
  const perMonthPrice = Math.round(price / divisor);

  if (pDisplay) pDisplay.textContent = money(perMonthPrice);
  if (perMo) perMo.textContent = '/mo';

  // Billing amount and cadence -- "$147 every 3 months". This row stays on show
  // when the card collapses, so it states the sum actually charged rather than
  // the per-month figure the headline divides it into.
  if (bTotal) bTotal.textContent = money(price);
  // Cadence is stated by the card when it knows better than the month count can
  // say: Yummies bills on WEEK x 4 and WEEK x 12, so deriving "every 3 months"
  // from the multiplier here would contradict the copy directly above it and
  // misstate when the customer is charged.
  if (bLabel) {
    bLabel.textContent =
      label.dataset.billingCadence ||
      (divisor > 1 ? 'every ' + divisor + ' months' : 'every month');
  }
  // The subscription cards carry no .compare-at-price-display since 12 Sep
  // 2026: the struck per-month base was removed by request, the badge and the
  // "Save $x" line being enough. Only the Buy Once branch above fills one.
  //
  // The tiers are advertised as a flat 20% and 30%, so the badge states the
  // offer rather than the arithmetic. Deriving it made the same tier read a
  // different number per variant purely from rounding -- Yummies Sugar Free
  // came out at 21%/29% off a $39 unit while Low Sugar landed on 20%/30% off
  // $35. The struck price and "Save $X" stay computed: those are exact
  // dollar figures, and it is only the percentage that rounds badly.
  const radio = label.querySelector('input[name="purchase_option"]');
  const fixedPct = radio ? parseInt(radio.dataset.savePercent, 10) : NaN;
  let pct = 0;
  if (formulaBase > price && formulaBase > 0) {
    pct = isNaN(fixedPct) ? Math.round(((formulaBase - price) / formulaBase) * 100) : fixedPct;
  }

  // Parked on the card so the CTA can restate the same figure. Deriving it a
  // second time in each flavour script is what let the button and the badge
  // above it disagree.
  if (pct > 0) label.dataset.prSavePct = String(pct);
  else delete label.dataset.prSavePct;

  if (sLabel) {
    if (pct > 0) {
      sLabel.textContent = 'Save ' + pct + '%';
      sLabel.style.display = 'inline-block';
    } else {
      sLabel.style.display = 'none';
    }
  }
};

// The Add to Cart label sells the subscription when one is selected, restating
// the saving from the selected card rather than recomputing it. Buy Once and
// sold-out keep the plain labels.
window.PRPurchase.ctaText = function (container, available) {
  if (!available) return 'SOLD OUT';
  const radio = container.querySelector('input[name="purchase_option"]:checked');
  if (!radio) return 'ADD TO CART';
  const kind = radio.dataset.planKind || '';
  if (kind === 'onetime' || radio.value === 'onetime') return 'ADD TO CART';
  const label = radio.closest('.purchase-option-label');
  const pct = label ? parseInt(label.dataset.prSavePct, 10) : NaN;
  return pct > 0 ? 'SUBSCRIBE AND SAVE ' + pct + '% OFF' : 'SUBSCRIBE AND SAVE';
};

// The pack grid sits inside the Buy Once card, so the pack chosen there is that
// card's state rather than the page's. Picking 3-Pack and then a subscription
// used to leave it selected: the collapsed "Buy Once for $X" link went on
// quoting three bottles, and reopening the card showed a pack picked in a
// purchase mode the shopper had since left. Selecting any subscription snaps it
// back to whichever button the markup shipped selected. `onReset` hands that
// pack to the flavour script so it can sync its own copy of the state and
// re-price.
window.PRPurchase.bindBuyOncePackReset = function (container, onReset) {
  const grid = container.querySelector('.purchase-option-onetime [data-pack-selector]');
  if (!grid) return;
  const buttons = Array.prototype.slice.call(grid.querySelectorAll('.pack-button'));
  if (!buttons.length) return;
  const initial = grid.querySelector('.pack-button.is-selected-pack') || buttons[0];
  const initialPack = initial.dataset.packValue;

  container.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (!radio.checked || radio.value === 'onetime') return;
      if (initial.classList.contains('is-selected-pack')) return;
      buttons.forEach(function (b) {
        b.classList.remove('is-selected-pack');
      });
      initial.classList.add('is-selected-pack');
      if (typeof onReset === 'function') onReset(initialPack);
    });
  });
};

// Buy Once is collapsed behind a text link (see .js-buy-once-toggle in
// pure-rose-pdp.css). Opening it also selects it, and the change event is
// dispatched for real so every existing price/ATC listener runs untouched.
window.PRPurchase.bindBuyOnceToggle = function (container, options) {
  const toggle = container.querySelector('.js-buy-once-toggle');
  const radio = container.querySelector('#purchase-option-onetime');
  if (!toggle || !radio) return;

  // A flavour can sell Buy Once outright instead of opening the card: the link
  // sends its pack straight to the cart, so there is no panel to expand and
  // whichever subscription card the shopper had selected stays selected.
  const instant = options && typeof options.onBuyOnceClick === 'function' ? options.onBuyOnceClick : null;
  if (instant) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      instant(toggle);
    });
    return;
  }

  const setOpen = function (isOpen) {
    container.classList.toggle('is-buy-once-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  };

  toggle.addEventListener('click', function () {
    setOpen(true);
    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Only one card stays open, Buy Once included: choosing a subscription card
  // sends it back behind the link. Driven off `change` on every radio rather
  // than the click above, so programmatic selection collapses it too.
  container.querySelectorAll('input[name="purchase_option"]').forEach(function (r) {
    r.addEventListener('change', function () {
      setOpen(radio.checked);
    });
  });

  // Never leave a checked option hidden behind the link.
  setOpen(radio.checked);
};

window.PRPurchase.bindSelection = function (container, options) {
  const radios = container.querySelectorAll('input[name="purchase_option"]');
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      radios.forEach(function (r) {
        const label = r.closest('label');
        if (label) label.classList.toggle('is-selected', r.checked);
      });
    });
  });
  window.PRPurchase.bindBuyOnceToggle(container, options);
};

window.PRPurchase.bindBanner = function (root) {
  const note = root.querySelector('.js-subscription-management-note');
  function update() {
    if (!note) return;
    const selected = root.querySelector('input[name="purchase_option"]:checked');
    const isSub = selected && selected.value !== 'onetime';
    note.style.display = isSub ? '' : 'none';
  }
  root.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
    radio.addEventListener('change', update);
  });
  update();
};

window.PRPurchase.bindOfferAccordions = function (root) {
  function update() {
    const offer = root.querySelector('[data-pr-offer-radio]:checked');
    // The option value is "Sugar-Free" in Shopify, so the separator is a hyphen
    // and \s* never matched it -- the class never landed and the PDP always
    // showed the regular copy. Same fold as the formula key in
    // pr-buybox-yummies.liquid, so re-spaced or re-cased copy still matches.
    const sf = offer && /sugar[^a-z0-9]*free/i.test(offer.value);
    root.classList.toggle('is-sugar-free', !!sf);
  }
  root.querySelectorAll('[data-pr-offer-radio]').forEach(function (input) {
    input.addEventListener('change', update);
  });
  update();
};

window.PRPurchase.bindVideos = function (root) {
  root.querySelectorAll('[data-pr-video]').forEach(function (video) {
    const play = function () {
      video.play().catch(function () {});
    };
    if (video.readyState >= 2) play();
    else video.addEventListener('canplay', play, { once: true });
  });
};
